import { Component } from '@angular/core';

@Component({
  selector: 'app-shared-placeholder',
  templateUrl: './shared-placeholder.component.html',
  styleUrl: './shared-placeholder.component.css',
  standalone: false
})
export class SharedPlaceholderComponent {}
